import { Badge } from "@salestrak/ui";

import type { FormSubmissionStatus } from "#app/lib/forms";

// "In progress", never "Draft": draft is reserved for an editable working copy.
export const SUBMISSION_STATUS_LABEL: Record<FormSubmissionStatus, string> = {
  inProgress: "In progress",
  submitted: "Submitted",
};

export function SubmissionStatusBadge({
  status,
  count,
}: {
  status: FormSubmissionStatus;
  count?: number;
}) {
  const label = SUBMISSION_STATUS_LABEL[status];
  return (
    <Badge color={status === "submitted" ? "success" : "warning"} tone="soft">
      {count === undefined ? label : `${count} ${label.toLowerCase()}`}
    </Badge>
  );
}
